import React, { memo, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import PerfectScrollbar from "react-perfect-scrollbar";

import Select from "react-select";
import CustomSelectInput from "../../../components/common/CustomSelectInput";
import { GetSelectTime, SetSelectTime } from "../../../helpers/SelectTime";
import { AddCommaNumber } from "../../../helpers/Utils";
import DynamicForm from "../general/DynamicForm";
import TooltipItem from "../../../components/common/TooltipItem";

const ContentComponent = ({
  title,
  isOpen,
  toggle,
  onSubmit,
  data_dynamic_form,
  values,
  setting,
  onChange,
  onChangeDynamicForm,
}) => {
  console.log("values: ", values);
  const [timeTooltip] = useState({
    placement: "top",
    text: "",
    body: 'Nếu chọn "Đưa vào thống kê" thì số liệu này sẽ được tính như một khoản chi trong ngày. Nếu chọn "Không đưa vào thống kê" thì chỉ xem như một con số tượng trưng.',
  });
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      wrapClassName="modal-right"
      backdrop={true}
      autoFocus={false}
    >
      <Form onSubmit={(e) => onSubmit(e)}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody className="scrool modal-right-add">
          <PerfectScrollbar
            options={{
              suppressScrollX: true,
              wheelPropagation: false,
            }}
            id="modal-right__body"
          >
            <FormGroup className="mt-3 has-float-label">
              <Label for="name" className="text-muted">
                <IntlMessages id="treasury.name" />
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                autoFocus={true}
                type="text"
                name="name"
                id="name"
                disabled={setting.viewonly && !setting.add}
                value={values.name}
                onChange={onChange}
              />
            </FormGroup>
            <FormGroup className="has-float-label">
              <Label for="value" className="text-muted">
                <IntlMessages id="price" />
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="text"
                name="value"
                id="value"
                disabled={setting.viewonly && !setting.add}
                value={AddCommaNumber(values.value)}
                onChange={onChange}
              />
            </FormGroup>
            <FormGroup className="has-float-label">
              <Label for="note" className="text-muted">
                <IntlMessages id="note" />
              </Label>
              <Input
                type="text"
                name="note"
                id="note"
                disabled={setting.viewonly && !setting.add}
                value={values.note}
                onChange={onChange}
              />
            </FormGroup>

            {/* ========== THÔNG TIN KHẤU HAO TÀI SẢN ========== */}
            <hr className="my-3" />
            <h6 className="text-primary mb-3">📊 Thông tin khấu hao</h6>

            <FormGroup className="has-float-label">
              <Label for="purchase_date" className="text-muted">
                Ngày mua tài sản
              </Label>
              <Input
                type="date"
                name="purchase_date"
                id="purchase_date"
                disabled={setting.viewonly && !setting.add}
                value={values.purchase_date || ""}
                onChange={onChange}
              />
            </FormGroup>

            <FormGroup className="has-float-label">
              <Label for="category" className="text-muted">
                Loại tài sản
              </Label>
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                name="category"
                isDisabled={setting.viewonly && !setting.add}
                value={[
                  { value: "equipment", label: "🔧 Thiết bị" },
                  { value: "furniture", label: "🪑 Nội thất" },
                  { value: "vehicle", label: "🚗 Phương tiện" },
                  { value: "renovation", label: "🏠 Cải tạo/Sửa chữa" },
                  { value: "other", label: "📦 Khác" },
                ].find((opt) => opt.value === values.category)}
                placeholder="Chọn loại tài sản"
                options={[
                  { value: "equipment", label: "🔧 Thiết bị" },
                  { value: "furniture", label: "🪑 Nội thất" },
                  { value: "vehicle", label: "🚗 Phương tiện" },
                  { value: "renovation", label: "🏠 Cải tạo/Sửa chữa" },
                  { value: "other", label: "📦 Khác" },
                ]}
                onChange={(e) => onChange(e, "category")}
              />
            </FormGroup>

            <FormGroup className="has-float-label">
              <Label for="useful_life_months" className="text-muted">
                Thời gian sử dụng (tháng)
              </Label>
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                name="useful_life_months"
                isDisabled={setting.viewonly && !setting.add}
                value={[
                  { value: 12, label: "1 năm (12 tháng)" },
                  { value: 24, label: "2 năm (24 tháng)" },
                  { value: 36, label: "3 năm (36 tháng)" },
                  { value: 60, label: "5 năm (60 tháng)" },
                  { value: 120, label: "10 năm (120 tháng)" },
                ].find((opt) => opt.value === values.useful_life_months)}
                placeholder="Chọn thời gian khấu hao"
                options={[
                  { value: 12, label: "1 năm (12 tháng)" },
                  { value: 24, label: "2 năm (24 tháng)" },
                  { value: 36, label: "3 năm (36 tháng)" },
                  { value: 60, label: "5 năm (60 tháng)" },
                  { value: 120, label: "10 năm (120 tháng)" },
                ]}
                onChange={(e) => onChange(e, "useful_life_months")}
              />
            </FormGroup>

            <FormGroup className="has-float-label">
              <Label for="residual_value" className="text-muted">
                Giá trị còn lại cuối kỳ (VNĐ)
              </Label>
              <Input
                type="text"
                name="residual_value"
                id="residual_value"
                disabled={setting.viewonly && !setting.add}
                value={AddCommaNumber(values.residual_value || 0)}
                onChange={onChange}
                placeholder="Thường = 0"
              />
              <small className="text-muted">
                Để 0 nếu khấu hao hết giá trị
              </small>
            </FormGroup>

            <FormGroup className="has-float-label">
              <Label for="status" className="text-muted">
                Trạng thái
              </Label>
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                name="status"
                isDisabled={setting.viewonly && !setting.add}
                value={[
                  { value: "active", label: "✅ Đang sử dụng" },
                  { value: "inactive", label: "⏸️ Ngừng sử dụng" },
                  { value: "disposed", label: "🗑️ Đã thanh lý" },
                ].find((opt) => opt.value === values.status)}
                placeholder="Chọn trạng thái"
                options={[
                  { value: "active", label: "✅ Đang sử dụng" },
                  { value: "inactive", label: "⏸️ Ngừng sử dụng" },
                  { value: "disposed", label: "🗑️ Đã thanh lý" },
                ]}
                onChange={(e) => onChange(e, "status")}
              />
            </FormGroup>

            {/* Hiển thị khấu hao tự động tính */}
            {values.value && values.useful_life_months && (
              <div className="alert alert-info py-2">
                <strong>💰 Khấu hao/tháng:</strong>{" "}
                {AddCommaNumber(
                  Math.round(
                    (parseFloat(String(values.value).replace(/\./g, "")) -
                      (parseFloat(values.residual_value) || 0)) /
                      (values.useful_life_months || 60)
                  )
                )}{" "}
                đ
              </div>
            )}

            <hr className="my-3" />
            {/* {setting.update ? (
        <FormGroup>
          <Label for="user.created">
            <IntlMessages id="user.created" />
          </Label>
          <Input type="text" name="user.created" id="user.created"
            disabled={true}
            value={values.user}
            onChange={onChange}
          />
        </FormGroup>
      ) : null} */}

            <DynamicForm
              values={values.dynamic_form}
              data={data_dynamic_form}
              onChange={onChangeDynamicForm}
              disabled={setting.viewonly && !setting.add}
            />
          </PerfectScrollbar>
        </ModalBody>
        <ModalFooter>
          <Button color="primary">
            <IntlMessages id="treasury.btn-add" />
          </Button>{" "}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default memo(ContentComponent);
